import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default function useJobStatus() {
  const dueStatusList = [
    false,
    true,
  ];
  const dueStatusDisplay = [
    'ปกติ',
    'เกินกำหนด',
  ];

  function compareDate(date: string): number {
    return dayjs(date).diff(dayjs(), 'day');
  }

  /**
   * ฟังก์ชันนี้จะคำนวณห่างระหว่างวันที่กับวันที่อื่นๆ แล้วจะแสดงผลเป็นวัน สัปดาห์ เดือน หรือปี เช่น
   * วันที่ 1
   * @param {string} date - string - The date you want to compare.
   * @param {string | undefined} date2 - string | undefined = undefined
   * @returns ```
   * function dateDifferenceDisplay(date: string, date2: string | undefined = undefined) {
   *     const parseResult = dayjs(date).to(date2, true);
   *     if (parseResult.indexOf('days') > -1) return parseResult.replace('days', 'วัน');
   *     if (parse
   */
  function dateDifferenceDisplay(date: string, date2: string | undefined = undefined) {
    const parseResult = dayjs(date).to(date2, true);
    if (parseResult.indexOf('days') > -1) return parseResult.replace('days', 'วัน');
    if (parseResult.indexOf('weeks') > -1) return parseResult.replace('weeks', 'สัปดาห์');
    if (parseResult.indexOf('months') > -1) return parseResult.replace('months', 'เดือน');
    if (parseResult.indexOf('years') > -1) return parseResult.replace('years', 'ปี');
    if (parseResult.indexOf('a day') > -1) return '1 วัน';
    if (parseResult.indexOf('a week') > -1) return '1 สัปดาห์';
    if (parseResult.indexOf('a month') > -1) return '1 เดือน';
    if (parseResult.indexOf('a year') > -1) return '1 ปี';
    return 'ระบุไม่ได้';
  }

  /**
   * It takes a date and a status, and returns a string that tells you how many days are left until the
   * date, or if the date is overdue
   * @param {string} date - string - The date that you want to compare with the current date.
   * @param [status=PENDING] - The status of the task.
   * @returns - If status is DONE, return 'ปิดงานแล้ว'
   *   - If date is NORMAL, return 'ปกติ'
   *   - If dateDifference is greater than 1, return `เหลือเ
   */
  function dueDateDisplay(date: string, status = 'PENDING') {
    if (status === 'DONE') return 'ปิดงานแล้ว';
    if (date === 'NORMAL') return 'ปกติ';

    const dateDifference = compareDate(date);
    if (dateDifference > 1) return `เหลือเวลา ${dateDifferenceDisplay(date)}`;
    if (dateDifference === 0) return 'ภายในวันนี้';
    return `เกินกำหนด ${dateDifferenceDisplay(date)}`;
  }

  function getColor(date: string, status = 'PENDING') {
    if (status === 'DONE') return 'green';
    const dateDifference = compareDate(date);
    if (dateDifference > 30 || date === 'NORMAL') return 'green';
    if (dateDifference <= 30 && dateDifference > 1) return 'orange';
    return 'red';
  }

  const statusClassMap = (date: string, status = 'PENDING') => {
    if (status === 'DONE' || date === 'NORMAL') return 'block text-green-600 rounded py-1 text-center bg-green-200';

    const color = getColor(date);
    return `block text-${color}-600 rounded py-1 text-center bg-${color}-200`;
  };

  return {
    dueStatusList,
    dueStatusDisplay,
    getColor,
    statusClassMap,
    dueDateDisplay,
    dateDifferenceDisplay,
  };
}
